// Re-export TFunction from react-i18next for backwards compatibility
export type { TFunction } from 'i18next';

// Note: User auth state is provided by AuthContext in MsalAuthProvider.tsx
// Note: Language is handled by i18n directly (useTranslation hook)
// Note: Redux has been fully removed - all state now uses TanStack Query, Context, or local state

export enum FormAction {
  Create,
  Update,
  Delete,
  ReadOnly
}

export enum FormState {
  Unchanged,
  Changed
}

export interface Dict<T> {
  [id: string]: T;
}

export interface IUserRouteProps {
  component: any;
  isAuthenticated: boolean;
  path: string;
  exact?: boolean;
}

/** keys are references to runtime class names */
export interface IStyles {
  [styleName: string]: string;
}

export enum UILanguage {
  Fi = 'fi',
  En = 'en'
}

export enum EntryType {
  Product = 0,
  Mixture = 1,
  Measurement = 2,
  Other = 3
}

export enum ProductType {
  Product = 0,
  Mixture = 1
}

export interface ICoordinates {
  x: number;
  y: number;
}

export interface IEmployeeDetail {
  firstName: string;
  lastName: string;
  title: string;
  phone: string;
  linkedIn: string;
  twitter: string;
  image: string;
  intro: string;
}

export interface Theme {
  primary: string;
  secondary: string;
  tertiary: string;
  danger: string;
  baseFontColor: string;
  brandGrey: string;

  baseFontSize: string;
  buttonFontSize: string;
  fontSemibold: string;
  baseRadius: string;
}

export interface ValidationResult {
  name: string;
  description: string;
}

export interface RequestErrorRespond {
  validationErrors: ValidationResult[];
  title: string;
  status: number;
  detail: string;
  instance: string;
}

export enum ActionResult {
  Created,
  Updated,
  Deleted,
  Failed
}

export enum UserRole {
  Admin,
  User,
  Reader,
  Unknown
}
